export const CLIENT_VIEW_LOCALE_COOKIE = "mm_cv_locale";
export const CLIENT_VIEW_CURRENCY_COOKIE = "mm_cv_currency";
export const COOKIE_MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

function readCookie(name) {
  if (typeof document === "undefined") {
    return null;
  }
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function formatPreferenceCookie(name, value, { now = Date.now(), secure = false } = {}) {
  const expires = new Date(now + COOKIE_MAX_AGE_SECONDS * 1000).toUTCString();
  const securePart = secure ? "; Secure" : "";
  return `${name}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; expires=${expires}; SameSite=Lax${securePart}`;
}

function writeCookie(name, value) {
  if (typeof document === "undefined") {
    return;
  }
  const secure = typeof window !== "undefined" && window.location?.protocol === "https:";
  document.cookie = formatPreferenceCookie(name, value, { secure });
}

export function readClientViewLocaleCookie() {
  return readCookie(CLIENT_VIEW_LOCALE_COOKIE);
}

export function writeClientViewLocaleCookie(locale) {
  if (!locale) return;
  writeCookie(CLIENT_VIEW_LOCALE_COOKIE, locale);
}

export function readClientViewCurrencyCookie() {
  return readCookie(CLIENT_VIEW_CURRENCY_COOKIE);
}

export function writeClientViewCurrencyCookie(currency) {
  if (!currency) return;
  writeCookie(CLIENT_VIEW_CURRENCY_COOKIE, currency);
}
